<template>
    <div class="main-block request-management">
        <Breadcrumbs />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.Office365Users') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <template slot>
                        <div class="d-flex justify-content-start">
                            <b-button variant="primary" @click="$router.go(-1)">
                                <b-icon icon="arrow-left" class="icon-style"></b-icon>
                            </b-button>
                            <b-button variant="primary" @click="handleUserAction">
                                <b-icon icon="person-plus" class="icon-style"></b-icon>
                            </b-button>
                            <b-button variant="primary"
                                @click="$router.push({ name: 'selectedInbox', params: { integrationId: $route.params.id } })">
                                <b-icon icon="envelope" class="icon-style"></b-icon>
                            </b-button>
                        </div>
                    </template>


                    <template #cell(actions)="{ item }">
                        <!-- Checkbox for selecting users -->
                        <input type="checkbox" :value="item.microsoft_user_id" v-model="selectedUsers" class="mr-2" />

                        <!-- Button with some margin-left for spacing -->
                        <b-button variant="light" class="ml-2"
                            @click="$router.push({ name: 'Inbox', params: { id: item.microsoft_user_id } })">
                            <b-icon variant="primary" icon="envelope" class="icon-style"></b-icon>
                        </b-button>
                    </template>


                    <!-- Display Response Payload -->
                    <template #cell(response_payload)="{ item }">
                        <div>
                            <div v-for="(value, key) in item.response_payload" :key="key"
                                class="d-flex justify-content-between align-items-center">
                                <span>
                                    <strong>{{ key }}</strong> :-{{ value }}
                                </span>
                            </div>
                        </div>
                    </template>


                    <!-- Display Created At Time -->
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ formatDate(item.created_at) }}
                            </span>
                        </div>
                    </template>
                </crud-table>

            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

const FILTER_FORM = {
    roles: null,
    statuses: null,
    integration_id: null // Adding the new filter for integration_id
};
const COLUMN_STATE = (self) => [
    { key: 'actions', label: self.$t('title.actions') },
    { key: 'integration_id', label: self.$t('title.integration_id'), sortable: true },
    { key: 'microsoft_user_id', label: self.$t('title.microsoft_user_id'), sortable: true },
    { key: 'user_principal_name', label: self.$t('title.user_principal_name'), sortable: true },
    { key: 'preferred_language', label: self.$t('title.preferred_language'), sortable: true },
    { key: 'office_location', label: self.$t('title.office_location'), sortable: true },
    { key: 'job_title', label: self.$t('title.job_title'), sortable: true },
    { key: 'surname', label: self.$t('title.surname'), sortable: true },
    { key: 'given_name', label: self.$t('title.given_name'), sortable: true },
    { key: 'full_name', label: self.$t('title.full_name'), sortable: true },
    { key: 'email', label: self.$t('title.email'), sortable: true },
    { key: 'phone', label: self.$t('title.phone'), sortable: true },
    { key: 'created_at', label: self.$t('title.created_at'), sortable: true }
];

export default {
    data() {
        return {
            query: {
                page: 1,
                perPage: 10,
            },
            pagination: {
                total: 0,
            },
            selectedUsers: [], // Store selected Microsoft User IDs
            filters: { ...FILTER_FORM },
        };
    },
    components: { Breadcrumbs },
     mounted() {
        if(this.$route.query.id) {
            this.$refs['application-table'].handleCustomSearch(this.$route.query.id);
        }
    },
    methods: {
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.$refs['application-table'].handleFilter({ filters: this.filters });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleString();
        },
        async handleUserAction() {
            this.isLoading = true; // optional loading state if needed
            const payload = {
                userIds: this.selectedUsers
            };

            try {
                const response = await request({
                    method: 'post',
                    url: '/admin/fetch-office-users-data',
                    data: payload,
                    headers: {
                        'Content-Type': 'application/json' // Content type for JSON data
                    }
                });

                // Assuming the API returns an object with a property `status` to indicate success:
                if (response.status === true) {
                    // Trigger toast notification
                    this.$bvToast.toast('User stored successfully!', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });
                } else {
                    // Optionally handle a failed status if needed
                    this.$bvToast.toast('User storage failed.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                }
            } catch (error) {
                console.error("Error storing user IDs:", error);
                this.errorMessage = error.response ? error.response.data.message : error.message;
                // You might also want to show an error toast
                this.$bvToast.toast(this.errorMessage, {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.isLoading = false;
            }
        }



    },
    computed: {
        listUrl() {
            const id = this.$route.params.id;
            return id ? `admin/Office365Users/${id}` : `admin/Office365Users`;
        },
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
